export const REGULAR_CLASS = 'regularClass';
export const COURSE = 'course';
export const QA = 'qa';
export const ACADEMY = 'academy';
export const RECOMMENDED = 'recommended';
export const BANNER = 'banner';

// for HeroSection
export const COVER = 'cover';
